import React from 'react';
import { ArcBaseSidebarProps } from './types';
import { ArcStack } from '@src/core/ui';

const baseSidebarSx = {
  p: 2,
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  boxSizing: 'border-box' as const,
  scrollbarWidth: 'none' as const,
  msOverflowStyle: 'none' as const,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

const ArcBaseSidebar: React.FC<ArcBaseSidebarProps> = ({ children, sx, ...rest }) => {
  return (
    <ArcStack
      width={400}
      overflow='auto'
      height='calc(100vh - 40px)'
      bgcolor='background.default'
      sx={[baseSidebarSx, ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : [])]}
      {...rest}>
      {children}
    </ArcStack>
  );
};

export default ArcBaseSidebar;
